<template>
  <main>
    <!--shop  area start-->
    <!-- <div class="shop_area shop_fullwidth shop_reverse pt-27">
      <div class="container">
          <div class="row">
              <div class="col-12">
                <product-sale :page_size="20"></product-sale>
              </div>
          </div>
      </div>
    </div> -->
    <!--shop  area end--> 
    <!--shop  area start-->
    <div class="shop_area shop_fullwidth shop_reverse pt-27">
      <div class="container">
          <div class="row">
              <div class="col-12">
                <product-list :page_size="40" title="Sản phẩm mới"></product-list>
              </div>
          </div>
      </div>
    </div>
    <!--shop  area end--> 
  </main>
</template>
<script>
import ProductList from "@/components/ProductList.vue";
// import ProductSale from "@/components/ProductSale.vue";
// import { loadScript } from "vue-plugin-load-script";
import _ from 'lodash';
export default {
  components: {
    'product-list': ProductList,
    // 'product-sale': ProductSale
  },
  mounted() {
    this.$root.$emit('COMPONENT_LOADED');
  }
}
</script>
